// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-button[data-v-e00472d2]{margin:0 5.208333rem}.flx_box[data-v-e00472d2]{height:3.125rem;display:flex;justify-content:center;align-items:center}.fu_box[data-v-e00472d2]{height:calc(100% - 18.48958rem)}.protocol[data-v-e00472d2]{overflow-y:auto;height:calc(100% - 3.125rem)}.anniu[data-v-e00472d2]{position:fixed;bottom:0;width:49.479167rem;margin:0 auto}", ""]);
// Exports
module.exports = exports;
